var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWarning = function SvgIcWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FB0",
    fillRule: "nonzero",
    width: 60,
    height: 60,
    rx: 30
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#39313D",
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
    fontSize: 46.666
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23.334,
    y: 47.334
  }, "!")))));
};
export default SvgIcWarning;